module.exports = __webpack_public_path__ + "img/qr-placeholder.09b5a9b5.svg";